import edit_add_column from './edit-add-column.svg';
import edit_add_minus_square from './edit-add-minus-square.svg';
import edit_add_plus from './edit-add-plus.svg';
import edit_add_plus_circle from './edit-add-plus-circle.svg';
import edit_add_plus_circle_filled from './edit-add-plus-circle-filled.svg';
import edit_add_plus_square from './edit-add-plus-square.svg';
import edit_add_row from './edit-add-row.svg';
import edit_add_to_queue from './edit-add-to-queue.svg';
import edit_bold from './edit-bold.svg';
import edit_close_circle from './edit-close-circle.svg';
import edit_close_circle_filled from './edit-close-circle-filled.svg';
import edit_close_square from './edit-close-square.svg';
import edit_columns from './edit-columns.svg';
import edit_combine_cells from './edit-combine-cells.svg';
import edit_copy from './edit-copy.svg';
import edit_crop from './edit-crop.svg';
import edit_delete_column from './edit-delete-column.svg';
import edit_delete_row from './edit-delete-row.svg';
import edit_double_quotes_left from './edit-double-quotes-left.svg';
import edit_double_quotes_right from './edit-double-quotes-right.svg';
import edit_edit_pencil_01 from './edit-pencil-01.svg';
import edit_edit_pencil_02 from './edit-pencil-02.svg';
import edit_edit_pencil_line_01 from './edit-pencil-line-01.svg';
import edit_edit_pencil_line_02 from './edit-pencil-line-02.svg';
import edit_font from './edit-font.svg';
import edit_heading from './edit-heading.svg';
import edit_heading_h1 from './edit-heading-h1.svg';
import edit_heading_h2 from './edit-heading-h2.svg';
import edit_heading_h3 from './edit-heading-h3.svg';
import edit_heading_h4 from './edit-heading-h4.svg';
import edit_heading_h5 from './edit-heading-h5.svg';
import edit_heading_h6 from './edit-heading-h6.svg';
import edit_hide from './edit-hide.svg';
import edit_italic from './edit-italic.svg';
import edit_layer from './edit-layer.svg';
import edit_layers from './edit-layers.svg';
import edit_list_add from './edit-list-add.svg';
import edit_list_check from './edit-list-check.svg';
import edit_list_checklist from './edit-list-checklist.svg';
import edit_list_ordered from './edit-list-ordered.svg';
import edit_list_remove from './edit-list-remove.svg';
import edit_list_unordered from './edit-list-unordered.svg';
import edit_mention from './edit-mention.svg';
import edit_move from './edit-move.svg';
import edit_move_horizontal from './edit-move-horizontal.svg';
import edit_move_vertical from './edit-move-vertical.svg';
import edit_paperclip_attachment_horizontal from './edit-paperclip-attachment-horizontal.svg';
import edit_paperclip_attachment_tilt from './edit-paperclip-attachment-tilt.svg';
import edit_paragraph from './edit-paragraph.svg';
import edit_path from './edit-path.svg';
import edit_redo from './edit-redo.svg';
import edit_remove_minus from './edit-remove-minus.svg';
import edit_remove_minus_circle from './edit-remove-minus-circle.svg';
import edit_remove_minus_circle_filled from './edit-remove-minus-circle-filled.svg';
import edit_rows from './edit-rows.svg';
import edit_ruler from './edit-ruler.svg';
import edit_select_multiple from './edit-select-multiple.svg';
import edit_show from './edit-show.svg';
import edit_single_quotes_left from './edit-single-quotes-left.svg';
import edit_single_quotes_right from './edit-single-quotes-right.svg';
import edit_sort_ascending from './edit-sort-ascending.svg';
import edit_sort_descending from './edit-sort-descending.svg';
import edit_strikethrough from './edit-strikethrough.svg';
import edit_swatches_palette from './edit-swatches-palette.svg';
import edit_table from './edit-table.svg';
import edit_table_add from './edit-table-add.svg';
import edit_table_remove from './edit-table-remove.svg';
import edit_text from './edit-text.svg';
import edit_text_align_center from './edit-text-align-center.svg';
import edit_text_align_justify from './edit-text-align-justify.svg';
import edit_text_align_left from './edit-text-align-left.svg';
import edit_text_align_right from './edit-text-align-right.svg';
import edit_underline from './edit-underline.svg';
import edit_undo from './edit-undo.svg';

export const V2_EDIT_ICONS: { [char: string]: string } = {
  edit_add_column,
  edit_add_minus_square,
  edit_add_plus,
  edit_add_plus_circle,
  edit_add_plus_circle_filled,
  edit_add_plus_square,
  edit_add_row,
  edit_add_to_queue,
  edit_bold,
  edit_close_circle,
  edit_close_circle_filled,
  edit_close_square,
  edit_columns,
  edit_combine_cells,
  edit_copy,
  edit_crop,
  edit_delete_column,
  edit_delete_row,
  edit_double_quotes_left,
  edit_double_quotes_right,
  edit_edit_pencil_01,
  edit_edit_pencil_02,
  edit_edit_pencil_line_01,
  edit_edit_pencil_line_02,
  edit_font,
  edit_heading,
  edit_heading_h1,
  edit_heading_h2,
  edit_heading_h3,
  edit_heading_h4,
  edit_heading_h5,
  edit_heading_h6,
  edit_hide,
  edit_italic,
  edit_layer,
  edit_layers,
  edit_list_add,
  edit_list_check,
  edit_list_checklist,
  edit_list_ordered,
  edit_list_remove,
  edit_list_unordered,
  edit_mention,
  edit_move,
  edit_move_horizontal,
  edit_move_vertical,
  edit_paperclip_attachment_horizontal,
  edit_paperclip_attachment_tilt,
  edit_paragraph,
  edit_path,
  edit_redo,
  edit_remove_minus,
  edit_remove_minus_circle,
  edit_remove_minus_circle_filled,
  edit_rows,
  edit_ruler,
  edit_select_multiple,
  edit_show,
  edit_single_quotes_left,
  edit_single_quotes_right,
  edit_sort_ascending,
  edit_sort_descending,
  edit_strikethrough,
  edit_swatches_palette,
  edit_table,
  edit_table_add,
  edit_table_remove,
  edit_text,
  edit_text_align_center,
  edit_text_align_justify,
  edit_text_align_left,
  edit_text_align_right,
  edit_underline,
  edit_undo,
};

export const V2_EDIT_ICON_NAMES: string[] = Object.keys(V2_EDIT_ICONS);
